import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Container,
    Grid,
    Box,
    CircularProgress,
    Avatar,
    IconButton,
    Menu,
    MenuItem as DropdownMenuItem
} from "@mui/material";
import { styled } from "@mui/material/styles";
import BookingCard from "./BookingCard";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import NewBooking from "./NewBooking";
const StyledAppBar = styled(AppBar)(({ theme }) => ({
    backgroundColor: "white",
    boxShadow: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

const Logo = styled(Typography)(({ theme }) => ({
    fontWeight: "bold",
    color: theme.palette.text.primary,
}));

const AddButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "20px",
    "&:hover": {
        backgroundColor: theme.palette.primary.dark,
    },
}));

const Dashboard = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const userName = location.state?.name || "User";
    const userid = location.state?.id || "0";
    const [showNewBooking, setShowNewBooking] = useState(false);
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    // State for the user menu dropdown
    const [anchorEl, setAnchorEl] = useState(null);

    const handleLogout = () => {
        navigate("/");
    };

    const fetchBookings = async () => {
        try {
            const response = await fetch(`${apiUrl}/appointments/upcoming/${userid}`);
            if (!response.ok) throw new Error("Failed to fetch bookings");
            const data = await response.json();
            setBookings(data.result);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchBookings();
    }, [showNewBooking]);

    useEffect(() => {
        fetchBookings();
    }, [userid]);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
            <StyledAppBar position="static">
                <Toolbar>
                    <Logo variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        <img src={"./logo.png"} height={"30px"} />
                    </Logo>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={handleMenuClick}>
                            <Avatar sx={{ marginRight: 1 }}>{userName[0]}</Avatar>
                            <Typography>{userName}</Typography>
                            <ArrowDropDownIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            <DropdownMenuItem onClick={handleLogout}>Logout</DropdownMenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </StyledAppBar>

            <Container maxWidth="lg" sx={{ mt: 4 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h5" component="h1">
                        Upcoming appointments
                    </Typography>
                    <AddButton
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => setShowNewBooking(true)}
                    >
                        Add
                    </AddButton>
                </Box>

                {loading ? (
                    <CircularProgress />
                ) : error ? (
                    <Typography color="error">{error}</Typography>
                ) : (
                    <Grid container spacing={3}>
                        {bookings && bookings.map((booking, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <BookingCard booking={booking} refreshDashboard={()=>fetchBookings()} />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Container>
            <NewBooking showNewBooking={showNewBooking} setShowNewBooking={setShowNewBooking} donorId={userid} />
        </Box>
    );
};

export default Dashboard;
